/* eslint-disable no-undef */
import axios from 'axios';
import hardRedirect from '../hardRedirect';
import Cookies from 'js-cookie';
import getUrlPrefix from '../getUrlPrefix';

/**
 * @export
 * @param {String} url
 * @param {Object} data
 * @param {Boolean} [auth=true]
 *  @param {Boolean} blobResponse
 *
 * @return {Promise}
 */
export default function postFile(url, data, auth = true, blobResponse = true) {
	const backendUrl = process.env.REACT_APP_REST_URL;
	const clientCookieName = 'offerto' + '_' + getUrlPrefix();

	const modifiedData = Object.fromEntries(
		Object.entries(data).map(([key, value]) => {
			if (Array.isArray(value) && value.length === 0) {
				return [key, ['']];
			} else {
				return [key, value];
			}
		})
	);

	const token = Cookies.get(clientCookieName);

	const headers = {
		'Content-Type': 'multipart/form-data',
	};

	if (auth) {
		headers.Authorization = token ? `${token}` : '';
	}

	const timeout = 30000; // Timeout duration in milliseconds

	return new Promise((resolve, reject) => {
		const timeoutPromise = new Promise((_, reject) => {
			setTimeout(() => {
				reject(new Error('Request timed out'));
			}, timeout);
		});

		const axiosPromise = axios({
			method: 'POST',
			withCredentials: true,
			responseType: blobResponse ? 'blob' : 'json',
			data: modifiedData,
			headers: headers,
			baseURL: `${backendUrl}/index.php?org_url=${window.location.pathname}&act=${url}`,
		})
			.then((response) => {
				if (response.status === 401 && url !== 'downloadFile') {
					Cookies.remove(clientCookieName);
					hardRedirect('/login');
				}

				resolve(response.data);
			})
			.catch((error) => {
				validateUserAction(error.response, url, clientCookieName);
				reject(error);
			});

		Promise.race([axiosPromise, timeoutPromise]).catch(reject);
	});
}
